import { GraduationCap, Award, Globe } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Tag } from "@/components/portfolio/Reveal";

export const Education = () => {
  const { t } = useLang();
  const e = t.education;
  const x = t.extras;
  return (
    <section id="education" data-testid="education-section" className="bg-mist py-24 md:py-32">
      <div className="max-w-[88rem] mx-auto px-5 md:px-10">
        <Reveal className="flex flex-col gap-5 mb-14">
          <Tag>{e.tag}</Tag>
          <h2 className="font-extrabold text-ink text-4xl md:text-5xl tracking-tight">{e.title}</h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-10">
          {e.degrees.map((d, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="h-full bg-white rounded-2xl p-7 border border-black/[0.06] hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center justify-between mb-5">
                  <span className="h-11 w-11 rounded-xl bg-brand/20 flex items-center justify-center">
                    <GraduationCap size={22} className="text-ink" />
                  </span>
                  <span className="font-extrabold text-brand-dark text-lg">{d.year}</span>
                </div>
                <p className="font-bold text-lg text-ink leading-snug">{d.title}</p>
                <p className="font-medium text-sm text-ink/55 mt-2">{d.org}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Languages */}
          <Reveal>
            <div className="h-full bg-ink rounded-2xl p-8">
              <div className="flex items-center gap-3 mb-6">
                <Globe size={20} className="text-brand" />
                <h3 className="font-bold text-lg text-white uppercase tracking-wide">{x.langTitle}</h3>
              </div>
              <div className="flex flex-col gap-4">
                {x.langs.map((l, i) => (
                  <div key={i} className="flex items-center justify-between border-b border-white/10 pb-3 last:border-b-0">
                    <span className="font-bold text-xl text-white">{l.name}</span>
                    <span className="font-medium text-sm text-brand">{l.level}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          {/* Certifications */}
          <Reveal delay={0.1}>
            <div className="h-full bg-white rounded-2xl p-8 border border-black/[0.06]">
              <div className="flex items-center gap-3 mb-6">
                <Award size={20} className="text-brand-dark" />
                <h3 className="font-bold text-lg text-ink uppercase tracking-wide">{x.certsTitle}</h3>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                {x.certs.map((c, i) => (
                  <div key={i} className="flex items-start gap-2.5">
                    <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-brand shrink-0" />
                    <span className="font-medium text-sm text-ink/75 leading-snug">{c}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
